import React, { useState } from 'react';
import { Coins, Check, Sparkles, ArrowLeft, Zap, ShieldCheck, CreditCard, Clock } from 'lucide-react';
import Modal from '../../components/ui/Modal';
import Button from '../../components/ui/Button';

export function RechargeCreditModal({
  isOpen,
  onClose,
  currentCredits = 0,
  onAddCredits
}) {
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [step, setStep] = useState('PACKAGES'); // 'PACKAGES' | 'PAYMENT'

  const packages = [
    {
      id: 'studio',
      name: 'Gói Studio Doanh Nghiệp',
      credits: 600,
      bonus: 150,
      totalCredits: 750,
      price: '99.000đ',
      originalPrice: '799.000đ',
      videoEstimate: '~75 video',
      popular: true,
      tag: '🔥 Siêu Ưu Đãi Đặc Biệt • 750 Credit chỉ 99k',
      description: 'Trọn gói đầy đủ tính năng: tạo ~75 video so sánh chuẩn 9:16 Full HD tốc độ cao với toàn bộ kho giọng AI và tạo mascot.'
    }
  ];

  const handleSelectPayment = (pkg) => {
    setSelectedPkg(pkg);
    setStep('PAYMENT');
  };

  const handleQuickRecharge = (pkg) => {
    onAddCredits(pkg.totalCredits);
    onClose();
  };

  const handleConfirmPaid = () => {
    if (selectedPkg) {
      onAddCredits(selectedPkg.totalCredits);
      setStep('PACKAGES');
      onClose();
    }
  };

  const handleModalClose = () => {
    setStep('PACKAGES');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleModalClose}
      title={step === 'PACKAGES' ? 'Nạp Thêm Credit Render Video' : 'Thanh Toán Gói Credit'}
      maxWidth={step === 'PACKAGES' ? '560px' : '520px'}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {/* Step 1: Packages List */}
        {step === 'PACKAGES' && (
          <>
            {/* Balance & Info Banner */}
            <div
              style={{
                background: 'linear-gradient(135deg, rgba(234, 88, 12, 0.08) 0%, rgba(255, 107, 53, 0.04) 100%)',
                border: '1px solid rgba(234, 88, 12, 0.2)',
                borderRadius: 'var(--radius-md)',
                padding: '14px 18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '12px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div
                  style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '12px',
                    background: 'var(--primary-gradient)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 10px rgba(234, 88, 12, 0.3)',
                    flexShrink: 0
                  }}
                >
                  <Coins size={22} color="#FFFFFF" />
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '12px', color: 'var(--text-muted)', fontWeight: 600 }}>
                      Số dư hiện có:
                    </span>
                    <strong style={{ fontSize: '18px', color: 'var(--primary)', fontWeight: 800 }}>
                      {currentCredits}
                    </strong>
                    <span style={{ fontSize: '12px', color: 'var(--primary)', fontWeight: 700 }}>
                      credit
                    </span>
                  </div>
                  <p style={{ fontSize: '12px', color: 'var(--text-dim)', marginTop: '2px' }}>
                    Mỗi video so sánh Full HD 9:16 (~30s) kèm giọng AI và mascot tốn trung bình <strong>8 - 12 credit</strong>.
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '4px 10px',
                  background: 'rgba(16, 185, 129, 0.12)',
                  borderRadius: 'var(--radius-full)',
                  border: '1px solid rgba(16, 185, 129, 0.25)',
                  color: '#059669',
                  fontSize: '11px',
                  fontWeight: 700,
                  whiteSpace: 'nowrap'
                }}
              >
                <Zap size={12} />
                <span>Nạp tự động 24/7</span>
              </div>
            </div>

            {/* Single Featured Package Card */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {packages.map((pkg) => (
                <div
                  key={pkg.id}
                  style={{
                    padding: '20px 22px',
                    borderRadius: 'var(--radius-md)',
                    background: 'linear-gradient(135deg, #FFF7ED 0%, #FFFFFF 60%, #FFFDFB 100%)',
                    border: '2px solid var(--primary)',
                    boxShadow: '0 8px 24px rgba(234, 88, 12, 0.14)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '14px',
                    position: 'relative'
                  }}
                >
                  {/* Top Badge */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span
                      style={{
                        fontSize: '11px',
                        fontWeight: 700,
                        padding: '3px 12px',
                        borderRadius: 'var(--radius-full)',
                        background: 'var(--primary-gradient)',
                        color: '#FFFFFF',
                        letterSpacing: '0.02em',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        boxShadow: '0 2px 8px rgba(234, 88, 12, 0.3)'
                      }}
                    >
                      {pkg.tag}
                    </span>

                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                      {pkg.originalPrice && (
                        <span style={{ fontSize: '13px', color: '#94A3B8', textDecoration: 'line-through' }}>
                          {pkg.originalPrice}
                        </span>
                      )}
                      <span style={{ fontSize: '22px', fontWeight: 800, color: 'var(--primary)', letterSpacing: '-0.02em' }}>
                        {pkg.price}
                      </span>
                    </div>
                  </div>

                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <h4 style={{ fontSize: '17px', fontWeight: 800, color: 'var(--text-main)' }}>
                        {pkg.name}
                      </h4>
                      <span
                        style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          background: '#ECFDF5',
                          color: '#059669',
                          border: '1px solid rgba(16, 185, 129, 0.3)',
                          padding: '2px 8px',
                          borderRadius: 'var(--radius-full)'
                        }}
                      >
                        +Tặng {pkg.bonus} credit
                      </span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                      <span style={{ fontSize: '14px', fontWeight: 800, color: 'var(--primary)' }}>
                        {pkg.totalCredits} Credit
                      </span>
                      <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                        • Dựng được khoảng <strong>{pkg.videoEstimate}</strong> hoàn chỉnh
                      </span>
                    </div>

                    <p style={{ fontSize: '12px', color: 'var(--text-dim)', marginTop: '4px', lineHeight: 1.5 }}>
                      {pkg.description}
                    </p>
                  </div>

                  {/* Highlights list */}
                  <div
                    style={{
                      background: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '8px',
                      padding: '10px 14px',
                      border: '1px solid rgba(234, 88, 12, 0.15)',
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: '8px',
                      fontSize: '12px',
                      color: 'var(--text-main)'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Check size={14} color="#10B981" strokeWidth={3} />
                      <span>~75 video so sánh 9:16</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Check size={14} color="#10B981" strokeWidth={3} />
                      <span>Không watermark Full HD</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Check size={14} color="#10B981" strokeWidth={3} />
                      <span>Mở khóa toàn bộ giọng AI</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Check size={14} color="#10B981" strokeWidth={3} />
                      <span>Credit không hết hạn</span>
                    </div>
                  </div>

                  {/* Actions */}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingTop: '4px' }}>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => handleQuickRecharge(pkg)}
                      title="Nạp ngay không cần chờ thanh toán (Môi trường thử nghiệm)"
                      style={{
                        fontSize: '12px',
                        padding: '8px 12px',
                        color: 'var(--text-dim)',
                        border: '1px dashed var(--border-color)'
                      }}
                    >
                      <Zap size={13} color="#EA580C" />
                      <span>Nạp test nhanh (+750)</span>
                    </Button>

                    <Button
                      size="md"
                      variant="primary"
                      onClick={() => handleSelectPayment(pkg)}
                      style={{ minWidth: '130px', fontWeight: 700 }}
                    >
                      <CreditCard size={15} />
                      <span>Thanh Toán</span>
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer Trust Notes */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '20px',
                paddingTop: '6px',
                fontSize: '12px',
                color: 'var(--text-dim)'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <ShieldCheck size={14} color="#10B981" />
                <span>Credit không bao giờ hết hạn</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Sparkles size={14} color="#EA580C" />
                <span>Hỗ trợ xuất video 1080x1920 không watermark</span>
              </div>
            </div>
          </>
        )}

        {/* Step 2: Coming Soon Payment View */}
        {step === 'PAYMENT' && selectedPkg && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {/* Back Bar */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button
                type="button"
                onClick={() => setStep('PACKAGES')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'var(--primary)',
                  fontSize: '13px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '4px 0'
                }}
              >
                <ArrowLeft size={16} />
                <span>Chọn gói cước khác</span>
              </button>

              <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
                Đang chọn: <strong style={{ color: 'var(--text-main)' }}>{selectedPkg.name} ({selectedPkg.totalCredits} Credit)</strong>
              </div>
            </div>

            {/* Coming Soon Notice Card */}
            <div
              style={{
                background: 'linear-gradient(135deg, #FAF8F5 0%, #FFF7ED 100%)',
                borderRadius: 'var(--radius-md)',
                padding: '28px 24px',
                border: '1.5px dashed rgba(234, 88, 12, 0.35)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: '14px'
              }}
            >
              <div
                style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '16px',
                  background: 'var(--primary-gradient)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 8px 20px rgba(234, 88, 12, 0.28)'
                }}
              >
                <Clock size={28} color="#FFFFFF" />
              </div>

              <div>
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    padding: '3px 12px',
                    borderRadius: 'var(--radius-full)',
                    background: '#FFEDD5',
                    color: '#EA580C',
                    display: 'inline-block',
                    marginBottom: '8px'
                  }}
                >
                  Cổng Thanh Toán Trực Tuyến
                </span>
                <h3 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--text-main)', letterSpacing: '-0.02em' }}>
                  Tính Năng Sắp Ra Mắt
                </h3>
              </div>

              <p style={{ fontSize: '13px', color: 'var(--text-muted)', lineHeight: 1.6, maxWidth: '420px' }}>
                Hệ thống thanh toán tự động qua cổng <strong>VietQR / Thẻ ngân hàng / Ví điện tử</strong> đang trong giai đoạn hoàn thiện và sẽ sớm ra mắt trong bản cập nhật tới để phục vụ bạn thuận tiện nhất.
              </p>

              {/* Free test notice box */}
              <div
                style={{
                  width: '100%',
                  background: '#FFFFFF',
                  borderRadius: 'var(--radius-sm)',
                  padding: '12px 16px',
                  border: '1px solid rgba(0, 0, 0, 0.08)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px',
                  marginTop: '4px'
                }}
              >
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-main)' }}>
                    {selectedPkg.name} ({selectedPkg.price})
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text-dim)' }}>
                    Nhận ngay <strong>+{selectedPkg.totalCredits} credit</strong> để dựng video
                  </div>
                </div>

                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    color: '#059669',
                    background: '#ECFDF5',
                    padding: '3px 8px',
                    borderRadius: '6px',
                    border: '1px solid rgba(16, 185, 129, 0.25)'
                  }}
                >
                  Miễn phí dùng thử
                </span>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button
                variant="outline"
                onClick={() => setStep('PACKAGES')}
              >
                Quay Lại
              </Button>

              <Button
                variant="primary"
                onClick={handleConfirmPaid}
                style={{ minWidth: '160px' }}
              >
                <Zap size={14} />
                <span>Nạp Thử Nghiệm (+{selectedPkg.totalCredits} credit)</span>
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default RechargeCreditModal;
